import {useState} from "react";
import {addWeeks} from "date-fns";
import FormWrapper from "./FormWrapper";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Upload from "./Upload";
import {BarLoader} from "react-spinners";

const FORM_ID = 'assembled-custom-form';

function AsassembledCustomForm() {
    const minDate = addWeeks(new Date(), 5);

    const [startDate, setStartDate] = useState(minDate);
    const [files, setFiles] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);


    return <FormWrapper
        url={process.env.REACT_APP_ASSEMBLED_CUSTOM_FORM_URL}
        formId={FORM_ID}
        files={files}
        onError={(message) => setErrorMessage(message)}
        onSubmit={()=>setErrorMessage(null)}
    >
        <fieldset key="contact" className={'contact'}>
            <header>Anfrage Full-Service-Montage</header>

            <div className="fields">

                <div className="field w-50">
                    <label>
                        <span>Vorname</span>
                        <input type="text" required={true} name={'first_name'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Nachname</span>
                        <input type="text" required={true} name={'last_name'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Wunschmontagewoche</span>
                        <DatePicker
                            name={'date'}
                            selected={startDate}
                            minDate={minDate}
                            locale={'de'}
                            dateFormat="'KW 'w"
                            showWeekNumbers={true}
                            weekLabel={"KW"}
                            showWeekPicker={true}
                            onChange={(date) => setStartDate(date)}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                        />
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Firma</span>
                        <input type="text" required={false} name={'company'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>E-Mail-Adresse</span>
                        <input type="email" required={true} name={'email'}/>
                    </label>
                </div>

                <div className="field w-50">
                    <label>
                        <span>Telefonnummer</span>
                        <input type="text" required={true} name={'phone'}/>
                    </label>
                </div>

                <div className="field">
                    <label>
                        <span>Montageort und weitere Hinweise</span>
                        <textarea name="message" rows="5" style={{resize: "none"}} maxLength={500}/>
                    </label>
                </div>
            </div>

            <div className="col">
                <div className="upload-panel">
                    <span className='headline'>Möchten Sie Pläne etc. hochladen?</span>
                    <p className={'instruction'}>Bis zu drei Dateien (JPG, PNG, PDF). Maximal 5MB pro Datei.</p>
                    <Upload onFilesChange={(files)=>setFiles(files)}/>
                </div>

                <button className={'fieldset-primary-button submit-button'}>
                    <span>Anfrage senden</span>
                    <BarLoader
                        className={'loader-animation'}
                        color="#ffffff"
                        height={2}
                        speedMultiplier={1}
                    />
                </button>

                {errorMessage && (
                    <div className="form-response---error-message">
                        {errorMessage}
                    </div>
                )}
            </div>

            <p className="legal-notice">
                Mit dem Absenden des Kontaktformulars verarbeiten und speichern wir Ihre Daten zur Bearbeitung Ihres Anliegens.
                In unserer <a href={"https://montas.de/datenschutz"} target={"_blank"} rel='noreferrer'>Datenschutzerklärung</a> finden Sie unsere Richtlinien zur Datenverarbeitung und Widerrufshinweise.
                Die Dienstleistungsangebote der montas GmbH richten sich ausschließlich an Unternehmer im Sinne von § 14 BGB.
            </p>
        </fieldset>
    </FormWrapper>;
}

export default AsassembledCustomForm;